import { FilterViewModel } from '../regulation';
import { ItemIdModel } from '../filter-model/item-id-model';

export class ImpactAssessmentDetailsDD {
    jurisdiction: Array<ItemIdModel>;
    assessor: Array<FilterViewModel>;
    assessorDelegate: Array<FilterViewModel>;
    reviewer: Array<FilterViewModel>;
    reviewerDelegate: Array<FilterViewModel>;
    implementationOwner: Array<FilterViewModel>;
    ownerDelegate: Array<FilterViewModel>;
    ruleTopics: Array<FilterViewModel>;
    pubType: Array<string>;

    constructor() {
        this.jurisdiction = [];
        this.assessor = [];
        this.assessorDelegate = [];
        this.reviewer = [];
        this.reviewerDelegate = [];
        this.implementationOwner = [];
        this.ownerDelegate = [];
        this.pubType = [];
        this.ruleTopics = [];
    }
}
